export interface Input {
  content: Marko.Body<
    [
      {
        buttonAttrs: {
          popovertarget: string;
          type: "button";
        };
        overlayAttrs: {
          id: string;
          onFocusOut: (event: FocusEvent) => void;
          onMouseDown: (event: MouseEvent, el: HTMLElement) => void;
          popover: true;
        };
      },
    ]
  >;
}

<id/popoverId>

<${input.content}
  buttonAttrs={
    popovertarget: popoverId,
    type: "button",
  }
  overlayAttrs={
    id: popoverId,
    onFocusOut(event: FocusEvent) {
      const el = this as unknown as HTMLElement;
      if (!event.relatedTarget || !el.contains(event.relatedTarget as Node)) {
        el.togglePopover({ force: false });
      }
    },
    // Safari doesn't focus buttons on click, so relatedTarget is null on
    // focusout and the popover closes before the click fires. Preventing
    // the default on mousedown stops focus from the current element, so
    // focusout never fires while the user is clicking inside the overlay.
    // Only apply when focus is already inside this overlay (the Safari
    // scenario), and skip form controls so they can still receive focus.
    onMouseDown(event: MouseEvent, el: HTMLElement) {
      const target = event.target as HTMLElement;
      const isFormControl = ["INPUT", "SELECT", "TEXTAREA"].includes(
        target.tagName,
      );
      if (!isFormControl && el.contains(document.activeElement)) {
        event.preventDefault();
      }
    },
    popover: true,
  }
/>
